<template>
    <div class="d-inline" :class="wrapperClass">
        <template v-if="labelPosition === 'left'">
            <span class="switch-title">{{ label }}</span>
            <div class="switch d-inline">
                <label :class="labelClass">
                    <input
                        type="checkbox"
                        :checked="checked"
                        @change="change"
                    >
                    <span class="lever"></span>
                </label>
            </div>
        </template>
        <template v-else>
            <div class="switch d-inline">
                <label :class="labelClass">
                    <input
                        type="checkbox"
                        :checked="checked"
                        @change="change"
                    >
                    <span class="lever"></span>
                </label>
            </div>
            <span class="switch-title">{{ label }}</span>
        </template>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    wrapperClass: {
      default: '',
      type: String,
      required: false
    },
    labelClass: {
      default: 'mr-3',
      type: String,
      required: false
    },
    label: {
      default: '',
      type: String,
      required: false
    },
    value: {
      default: false,
      type: String | Boolean,
      required: false
    },
    labelPosition: {
      default: 'left',
      type: String,
      required: false
    },
    inverted: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  computed: {
    checked () {
      if (typeof this.value === 'boolean') {
        if (this.inverted) {
          return !this.value
        }
        return this.value
      } else {
        if (this.inverted) {
          return !parseInt(this.value)
        }
        return parseInt(this.value)
      }
    }
  },
  methods: {
    change (event) {
      if (this.inverted) {
        this.$emit('input', !event.target.checked)
      } else {
        this.$emit('input', event.target.checked)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Lever.vue